import React from "react";
//Icons
import MatchIcon from 'react-icons/lib/md/insert-link';

import ToolTipItem from "../utils/tooltip";
 import ServerPaginatedTable from "../utils/pagination.server";
import {appHelpers} from "../../_helpers";
import {Link} from 'react-router-dom';


const UnmatchedPaymentTableStructure = ({data}) => (
    <table className="table table-striped table-hover">
        <thead>
        <tr>
            <th>Airline (Issuer)</th>
            <th>Location</th>
            <th>Issue Date</th>
             <th>Payment Amount</th>
            <th>Payment Date</th>
            <th>Action</th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, i) =>
            <tr key={i}>
                <td className='text-capitalize'>
                    { item.Issuer }
                </td>
                <td>{item.AccountCode}</td>
                <td>
                    {appHelpers.formatDate(item.IssueDate)}
                </td>
                <td>
                    { appHelpers.numberWithCommas(item.BilledAmount) }
                </td>
                <td>
                    {appHelpers.formatDate(item.PaymentDate)}
                </td>
                <td>
                <Link to={`/match-payment/${item.Id}`} className="text-primary pointer">
                    <ToolTipItem key={i + 'matchPayment'} title={<MatchIcon size="15" color="#43a8df"/>} content='Match Payment' id={i + 'matchPayment'}/>
                </Link>
                </td>
            </tr>)}
        </tbody>
    </table>
);
class UnmatchedRecords extends React.Component {
    render() {
        let { data, pageSize, currentPage, totalUnmatchPaymentsCount, pageDataCallBack } = this.props;
        return (
            <div>
                <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallBack} target={<UnmatchedPaymentTableStructure data={data}/>} pageSize={pageSize} totalCount={ totalUnmatchPaymentsCount }/>
            </div>
        )
    }
}
export default UnmatchedRecords;



// WEBPACK FOOTER //
// ./src/views/unmatchedPayment/unmatched-records.js